<template lang="pug">
  #target-estalishment-choice
    .title-block
      .title Etablissement existant
      .subtitle Choisissez un des établissements recommendés ou recherchez en un dans la base
    establishment-selector(
      :establishment="establishment"
      :selectedEstablishment="selectedEstablishment"
      :potentialEstablishments="potentialEstablishments"
      :sheetAggregates="sheetAggregates"
      @select="value => { $emit('selectEstablishment', value); goNext(); }"
    )
    .actions
      button.cancel-btn(@click="$emit('close')") Annuler
      button.previous-btn(@click="goBack") Precédent
      button.next-btn(@click="goNext" :disabled="!selectedEstablishment") Suivant
</template>

<script>
import EstablishmentSelector from '@/components/establishment-selector/EstablishmentSelector.vue';

export default {
  components: {
    EstablishmentSelector,
  },
  props: {
    establishment: {
      type: Object,
      required: true,
    },
    selectedEstablishment: {
      type: Object,
      default: null,
    },
    potentialEstablishments: {
      type: Array,
      default: () => [],
    },
    sheetAggregates: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'CreateOrMerge' });
    },
    goNext() {
      this.$router.push({ name: 'ActionSummary' });
    },
  },
}
</script>

<style lang="scss">
  #target-estalishment-choice {
    .title-block {
      margin-bottom: 1.5em;
    }
  }
</style>